var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0BB53A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85551 12C3.63805 12 3.4206 11.9192 3.24893 11.7461C2.91702 11.4113 2.91702 10.8573 3.24893 10.5225L6.9113 6.82878C7.09442 6.64409 7.33476 6.55175 7.598 6.57484C7.84979 6.59792 8.07868 6.73644 8.22747 6.95575L9.47496 8.84879L13.5379 4.75106C13.8698 4.41631 14.4192 4.41631 14.7511 4.75106C15.083 5.0858 15.083 5.63986 14.7511 5.9746L9.94421 10.8226C9.76109 11.0073 9.52074 11.0997 9.25751 11.0766C9.00572 11.0535 8.77682 10.915 8.62804 10.6957L7.38054 8.80262L4.46209 11.7461C4.29041 11.9192 4.07296 12 3.85551 12Z",
    fill: "#0FA73A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1964 9C13.7571 9 13.3929 8.56286 13.3929 8.03571V6.42857H12.0536C11.6143 6.42857 11.25 5.99143 11.25 5.46429C11.25 4.93714 11.6143 4.5 12.0536 4.5H14.1964C14.6357 4.5 15 4.93714 15 5.46429V8.03571C15 8.56286 14.6357 9 14.1964 9Z",
    fill: "#0FA73A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trendUp.aad7aa6103484027e446868d3087ceea.svg";
export { ForwardRef as ReactComponent };